export const ExclamationPointIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" />
        <path d="M8.5 10H7.5L7 7V3H9V7L8.5 10Z" fill="white" />
        <path d="M7 11H9V13H7V11Z" fill="white" />
    </svg>
);
